import { AxiosResponse } from "axios";
import { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Alert, Spinner } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericModal from "./GenericModal";

interface IParams {
  url: string;
  children: any;
  hasLoaderModal?: boolean;
  handleActionDownload?: (filename: string, href: string) => void;
  disabled?: boolean; //
  style?: any;
}

const ProtectedCaboloDownload: React.FC<IParams> = ({
  url,
  children,
  hasLoaderModal,
  handleActionDownload,
  disabled,
  style,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { loadDownloadableCabolo, theme,cancelDownloadFile } = rootStore.commonStore;
  const [showModal, setShowModal] = useState(false);
  const [downloadCompleted, setDownloadCompleted] = useState(false);
  const [t] = useTranslation(["toast", "features"], translationHookOptions);
  const link = useRef<HTMLAnchorElement | null>(null);

  const getFileName = (response: AxiosResponse<any> | undefined) => {
    let filename = "download";
    if (response && response.headers) {
      const disposition = response.headers["content-disposition"];
      if (disposition && disposition.indexOf("attachment") !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }
    }
    return filename;
  };

  const handleAction = async (e?: React.MouseEvent) => {
    // quwesto impedisce l'azione nativa dell'anchor tag
    e?.preventDefault(); // 👈 questo impedisce l'azione nativa dell'anchor tag

    console.log("start download")
    setShowModal(true);
    if (disabled) {
      return; // 👈 blocca click se disabilitato
    }
    if (link.current!.href && downloadCompleted) {
      setShowModal(false);
      setDownloadCompleted(false);
      return;
    }

    link.current!.removeAttribute("href");
    link.current!.removeAttribute("download");
    const result = await loadDownloadableCabolo(url);
    if (result && result.data && result.headers && link && link.current) {
      setDownloadCompleted(true);
      const filename = getFileName(result);

      const file = new File([result!.data], filename);
      console.log(file)
      const href = window.URL.createObjectURL(file);
      console.log(href)

      link.current!.download = filename;
      link.current!.href = href;
      link.current!.click();

      if (handleActionDownload) {
        handleActionDownload(filename, href);
        setShowModal(false);
        setDownloadCompleted(false);
      }
    } else {
      if(result)
        toast.error(t("file_not_found"));
      setShowModal(false);
      setDownloadCompleted(true);
  }   };

  return (
    <>
           <a role="button" href="/#"  className={disabled ? "disabledPretetectCaboloDownload-link" : ""} ref={link} onClick={(e)=>handleAction(e)} style={style? style : {}}>
        {children}
      </a>
      {hasLoaderModal && (
        <GenericModal
          isOpen={showModal}
          size="sm"
          cancelBtn={true}
          toggle={() => {setShowModal(false) ; cancelDownloadFile()}}
          content={
            <>
              <Alert
                color={theme ? theme.loaderColor : "red"}
                className="text-center mb-0"
              >
                <div className="mb-2">{t("downloading", { ns : "features" })}</div>
                <Spinner color="white" />
              </Alert>
            </>
          }
        />
      )}
    </>
  );
};

export default ProtectedCaboloDownload;
